/**
 * IconButton 컴포넌트
 * @description 라벨이 곧 아이콘인 버튼. 앱 DS `IconButton` 의 웹 포팅 — 앱
 *   `IconButton.design.md` 가 원본이다. 보이는 글자가 없으므로 `label` 이 필수다.
 * @example
 * <IconButton icon={<ChevronLeft />} label="Back" tone="ghost" radius="circle" onClick={back} />
 */
import { memo, type CSSProperties } from "react";

import { iconButtonStyles } from "./IconButton.styles";
import type { IconButtonProps } from "./IconButton.types";

/** 시안 기본 글리프 굵기 — `border.lg`. */
const DEFAULT_GLYPH_STROKE = 2;

const IconButton = memo<IconButtonProps>(
  ({
    icon,
    label,
    tone,
    size,
    radius,
    glyphStrokeWidth = DEFAULT_GLYPH_STROKE,
    className,
    type = "button",
    ...rest
  }) => (
    <button
      type={type}
      aria-label={label}
      className={iconButtonStyles({ tone, size, radius, className })}
      style={
        { "--ibtn-stroke-glyph": `${glyphStrokeWidth}px` } as CSSProperties
      }
      {...rest}
    >
      {icon}
    </button>
  ),
);

IconButton.displayName = "IconButton";

export default IconButton;
